import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, MapPin, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const SearchBar = ({ 
  initialValue = "", 
  onSearch = null, 
  placeholder = "Search beaches by name, city, or state...",
  size = "default",
  className = "",
}) => {
  const [query, setQuery] = useState(initialValue);
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSearch) {
      onSearch(query);
    } else {
      navigate(`/search?q=${encodeURIComponent(query)}`);
    }
  };

  const clearSearch = () => {
    setQuery("");
    if (onSearch) {
      onSearch("");
    }
  };

  const isLarge = size === "large";

  return (
    <form 
      onSubmit={handleSubmit} 
      className={`relative ${className}`}
      data-testid="search-form"
    >
      <div className={`bg-white flex items-center gap-3 rounded-full shadow-xl border-2 border-white hover:border-[#0EA5E9] transition-colors ${
        isLarge ? "px-6 py-4" : "px-4 py-2"
      }`}>
        <div className={`flex items-center justify-center rounded-full bg-[#0EA5E9] ${isLarge ? "w-10 h-10" : "w-8 h-8"}`}>
          <MapPin className={`text-white ${isLarge ? "w-5 h-5" : "w-4 h-4"}`} />
        </div>
        <Input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={placeholder}
          className={`flex-1 border-0 bg-transparent focus-visible:ring-0 focus-visible:ring-offset-0 placeholder:text-gray-400 text-gray-800 font-medium ${
            isLarge ? "text-lg h-12" : "h-10"
          }`}
          data-testid="search-input"
        />
        {query && (
          <button
            type="button"
            onClick={clearSearch}
            className="p-1.5 hover:bg-gray-100 rounded-full transition-colors"
            data-testid="clear-search-btn"
          >
            <X className="w-5 h-5 text-gray-400" />
          </button>
        )}
        <Button
          type="submit"
          className={`rounded-full bg-[#F97316] hover:bg-[#EA580C] text-white font-bold shadow-md ${
            isLarge ? "px-8 py-3 text-base" : "px-6 py-2"
          }`}
          data-testid="search-submit-btn"
        >
          <Search className={`${isLarge ? "w-5 h-5 mr-2" : "w-4 h-4 mr-1"}`} />
          Search
        </Button>
      </div>
    </form>
  );
};

export default SearchBar;
